import { render } from "./CouponCreate2.vue?vue&type=template&id=e1f286b4&scoped=true"
import script from "./CouponCreate2.vue?vue&type=script&lang=js"
export * from "./CouponCreate2.vue?vue&type=script&lang=js"

import "./CouponCreate2.vue?vue&type=style&index=0&id=e1f286b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1f286b4"]])

export default __exports__